import { useSetRecoilState } from 'recoil';
import { useIdleTimer } from 'react-idle-timer';
import moment from 'moment';
import { COOKIE_NAMES, SESSION_TIMEOUT_MINS } from 'config';
import useConfig from 'hooks/useConfig';
import { getCookie, setCookie, deleteCookie } from 'lib/cookies';
import { customerDetails } from 'state';

const useSessionTracker = () => {
  const { brand, env } = useConfig();
  const isSE = brand === 'SE';

  const setCustomer = useSetRecoilState(customerDetails);

  const handleOnTimeout = () => {
    if (isSE) {
      return;
    }
    deleteCookie(brand, env, COOKIE_NAMES.CUSTOMER_TOKEN);
    deleteCookie(brand, env, COOKIE_NAMES.LAST_USER_ACTIVITY);
    setCustomer(null);
  };

  const handleOnActivity = () => {
    if (isSE || !getCookie(brand, env, COOKIE_NAMES.LAST_USER_ACTIVITY)) {
      return;
    }
    const content = JSON.stringify(moment().format());
    const expires = new Date(new Date().getTime() + 1000 * 60 * SESSION_TIMEOUT_MINS);

    setCookie(brand, env, COOKIE_NAMES.LAST_USER_ACTIVITY, content, { expires });
  };

  useIdleTimer({
    timeout: 1000 * 60 * SESSION_TIMEOUT_MINS,
    onIdle: handleOnTimeout,
    onAction: handleOnActivity,
    debounce: 500
  });
};

export default useSessionTracker;
